import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as shareActions from 'modules/share';

import { ServiceShareSelect } from 'components';

class CtServiceShareSelect extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getServiceShareInfo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.needReload && nextProps.needReload !== this.props.needReload) {
      this.getServiceShareInfo();
    }
  }

  getServiceShareInfo = async () => {
    const { ShareActions } = this.props;

    try {
      await ShareActions.getShare();
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { isAuth, shareInfo, myInfo } = this.props;

    let respData = [];
    if (shareInfo && Map.isMap(shareInfo) && shareInfo.get('result') === 1) {
      respData = shareInfo.toJS().success;
    }

    const shareSelect = [];
    for (let i = 0, l = respData.length; i < l; i++) {
      const d = respData[i];
      if (myInfo.userNo === d.userNo) {
        shareSelect.push(d);
      }
    }

    if (shareSelect.length > 1) {
      return <ServiceShareSelect isAuth={isAuth} shareInfo={shareSelect} myInfo={myInfo} />;
    } else {
      return null;
    }
  }
}

CtServiceShareSelect.propTypes = {};
CtServiceShareSelect.defaultProps = {};

const mapStateToProps = state => {
  return {
    shareInfo: state.share.get('data'),
    needReload: state.share.get('needReload'),
    isAuth: state.user.get('isAuth'),
    myInfo: state.user.get('user')
  };
};

CtServiceShareSelect.propTypes = {
  shareInfo: PropTypes.object,
  myInfo: PropTypes.object
};
CtServiceShareSelect.defaultProps = {
  shareInfo: {},
  myInfo: {}
};

const mapDispatchToProps = dispatch => ({
  ShareActions: bindActionCreators(shareActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtServiceShareSelect);



// WEBPACK FOOTER //
// ./src/script/containers/share/CtServiceShareSelect.js